import Button from "components/Button";
import { formatNumber } from "helpers/formatNumber";
import { IInvoiceData } from "models/HaulPay";
import styles from "./style.module.scss";

interface IDuplicatedInvoice {
  data: IInvoiceData;
  goToInvoice: (item: IInvoiceData) => void;
}

export default function DuplicatedInvoiceForMobile({
  data,
  goToInvoice
}: Readonly<IDuplicatedInvoice>) {
  return (
    <ul className={styles.duplicatedInvoiceWrapper}>
      <li>
        <span>Invoice#</span>
        <span>{data.invoice_number}</span>
      </li>
      <li>
        <span>Carrier</span>
        <span>{data.payment_profile?.company_name}</span>
      </li>
      <li>
        <span>Debtor</span>
        <span>{data.debtor?.dba}</span>
      </li>
      <li>
        <span>Invoice Amt.</span>
        <span>{data.amount ? formatNumber(data.amount / 100, 2) : "-"}</span>
      </li>
      <li>
        <span>Link to Invoice</span>
        <Button type="button" onClick={() => goToInvoice(data)} className="!w-fit px-5">
          More
        </Button>
      </li>
    </ul>
  );
}
